import { httpClient } from "core/api-client";
import { appConfig } from "../shared/app-config";
import { TranslationService } from "./translation/translation-service";
import { LoginService } from "./login.service";
import { SpeechService } from "./speech/speech-service";
import { SpeechTokenCacheService } from "./speech/speech-token-service";
import MemoryCache from "core/store/memory-cache";
import { LanguageService } from "./language/language-service";
import { supportedLangauges } from "shared/config/constants";
import { AppService } from "./app/app-service";
import { FeedbackService } from "./feedback/feedback-service";
import { SessionService } from "./session/session-service";
import { ReportService } from "./report/report-service";
import { PhraseService } from "./phrase/phrase-service";

export const loginService = new LoginService(appConfig.API_URL, httpClient);

export const translationService = new TranslationService(appConfig.API_URL, httpClient);

export const speechService = new SpeechService(appConfig.API_URL, httpClient);

export const speechTokenCacheService = new SpeechTokenCacheService(speechService, new MemoryCache(5));

export const languageService = new LanguageService(supportedLangauges);

export const appService = new AppService(languageService);

export const feedbackService = new FeedbackService(appConfig.API_URL, httpClient);

export const sessionService = new SessionService(appConfig.API_URL, httpClient);

export const reportService = new ReportService(appConfig.API_URL, httpClient)

export const phraseService = new PhraseService(appConfig.API_URL, httpClient);